
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class ArsaBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "ArsaBasvuruSave";
    super(baseUrl);
  }


  saveArsaBasvuruSave(request: ArsaBasvuruRequest){
    
    return this.post("", request, true);
   
  }

}
export default new ArsaBasvuruAPI();
class ArsaBasvuruRequest {
 
    basvuruTuruId:number
    sicilKodu:number;
    pafta?:string;
    ada?:number;
    parsel?:number;
    mahalleKodu?:number;
    caddeSokakKodu?:number;
    mevki?:string;
    blokNo?:string;
    katNo?:string;
    tapuBagimsizNo?:string;
    kapiNo?:number;
    altKapiNo?:string;
    daireNo?:number;
    altDaireNo?:string;
    //kullanimSekliKodu?:number;
    //insaatTuruKodu?:number;
    siteApartmanAdi?:string;
    tapuCiltNo?:number;
    tapuSayfaNo?:number;
    arsaYuzolcumu?:number;
    arsaHisse?:number;
    arsaOran?:number;
    arsa2Hisse?:number;
    arsa2Oran?:number;
    edinmeTarihi?:string;
    aciklama?:string;
    tapuYevmiyeTarihi?:string;
    tapuYevmiyeNo?:string;
    pismanlikIndirimi?:string;


  
  constructor(basvuruTuruId: number,
    sicilKodu: number,
    pafta: string,
    ada?: number,
    parsel?: number,
    mahalleKodu?: number,
    caddeSokakKodu?: number,
    mevki?: string,
    blokNo?: string,
    katNo?: string,
    tapuBagimsizNo?: string,
    kapiNo?: number,
    altKapiNo?: string,
    daireNo?: number,
    altDaireNo?: string,
    //kullanimSekliKodu?: number,
    //insaatTuruKodu?: number,
    siteApartmanAdi?: string,
    tapuCiltNo?: number,
    tapuSayfaNo?: number,
    arsaYuzolcumu?: number,
    arsaHisse?: number,
    arsaOran?: number,
    arsa2Hisse?: number,
    arsa2Oran?: number,
    edinmeTarihi?: string,
    aciklama?: string,
    tapuYevmiyeTarihi?: string,
    tapuYevmiyeNo?: string,
    pismanlikIndirimi?:string
    ) {
   
    this.basvuruTuruId = basvuruTuruId;
    this.sicilKodu = sicilKodu;
    this.pafta = pafta;
    this.ada = ada;
    this.parsel = parsel;
    this.mahalleKodu = mahalleKodu;
    this.caddeSokakKodu = caddeSokakKodu;
    this.mevki = mevki;
    this.blokNo = blokNo;
    this.katNo = katNo;
    this.tapuBagimsizNo = tapuBagimsizNo;
    this.kapiNo = kapiNo;
    this.altKapiNo = altKapiNo;
    this.daireNo = daireNo;
    this.altDaireNo = altDaireNo;
    //this.kullanimSekliKodu = kullanimSekliKodu;
    //this.insaatTuruKodu = insaatTuruKodu;
    this.siteApartmanAdi = siteApartmanAdi;
    this.tapuCiltNo = tapuCiltNo;
    this.tapuSayfaNo = tapuSayfaNo;
    this.arsaYuzolcumu = arsaYuzolcumu;
    this.arsaHisse = arsaHisse;
    this.arsaOran = arsaOran;
    this.arsa2Hisse = arsa2Hisse;
    this.arsa2Oran = arsa2Oran;
    this.edinmeTarihi = edinmeTarihi;
    this.aciklama = aciklama;
    this.tapuYevmiyeTarihi = tapuYevmiyeTarihi;
    this.tapuYevmiyeNo = tapuYevmiyeNo;
    this.pismanlikIndirimi=pismanlikIndirimi;
  }
}
export { ArsaBasvuruRequest };
/*
*/



